import { useFetchPlanState, useFetchStateDataIfNull, useQuery } from '../../util/hooks';
import LargerHeaderWithNavLayout from '../../layouts/large-header-with-nav-layout';
import { StepBody } from '../../components/step-body';
import { ContractContent } from './components/contract-content';

export const Contract = () => {
  const query = useQuery();

  const queryParamCheckoutId = query.get('checkoutId');
  useFetchStateDataIfNull(queryParamCheckoutId);
  useFetchPlanState(); // Note: don't use useFetchPlanStateIfNull() here as this page needs a refreshed plans details

  return (
    <LargerHeaderWithNavLayout>
      <StepBody>
        <ContractContent />
      </StepBody>
    </LargerHeaderWithNavLayout>
  );
};
